import { render, staticRenderFns } from "./StepConfirmacaoSucesso.vue?vue&type=template&id=9512c0b4"
import script from "./StepConfirmacaoSucesso.vue?vue&type=script&lang=js"
export * from "./StepConfirmacaoSucesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports